export default ["Zobacz dostępne wersje"];
